var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_923",
    "data-name": "Group 923",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f3f3f3;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #848383;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    className: "cls-1",
    width: 53,
    height: 53,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-image",
    "data-name": "Icon metro-image",
    className: "cls-2",
    d: "M21.966,5.149l0,0V20.665l0,0H3.866l0,0V5.152l0,0Zm0-1.293H3.864A1.3,1.3,0,0,0,2.571,5.149V20.668a1.3,1.3,0,0,0,1.293,1.293h18.1a1.3,1.3,0,0,0,1.293-1.293V5.149A1.3,1.3,0,0,0,21.969,3.856ZM19.382,8.382a1.94,1.94,0,1,1-1.94-1.94,1.94,1.94,0,0,1,1.94,1.94Zm1.293,10.992H5.157V16.788L9.683,9.029l5.173,6.466h1.293l4.526-3.88Z",
    transform: "translate(13.584 13.784)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.009cbbfb3d815b52cd749e80c7ed5d54.svg";
export { ForwardRef as ReactComponent };